module.exports = __webpack_public_path__ + "img/shape-1.1cb848e0.svg";